import {
  baseQuery,
  CREATE_USER,
  DELETE_USER,
  EDIT_USER,
  GET_ALL_TD_CLIENTS,
  UPDATE_USER_STATUS,
} from "@/graphql";
import { createApi } from "@reduxjs/toolkit/query/react";
interface UserManagementResponse {
  data: IUser[];
  meta: {
    countDocs: number;
  };
}
interface AddEditUserResponse {
  data: boolean;
}

type ICreateUserInput = Pick<
  IUser,
  "firstName" | "lastName" | "email" | "userRight" | "allowedPages"
>;

type IUpdateUserInput = Pick<IUser, "firstName" | "lastName">;

// Define the API
export const userManagementApi = createApi({
  reducerPath: "api/userManagement",
  tagTypes: ["userManagement"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAllTdClients: builder.query<
      UserManagementResponse,
      {
        pageNo: number;
        pageSize: number;
        searchKeyword?: string;
        startDate?: string;
        endDate?: string;
        role?: string;
        isRestricted?: boolean;
      }
    >({
      query: (variables) => ({
        document: GET_ALL_TD_CLIENTS,
        variables: { ...variables },
      }),
      providesTags: ["userManagement"],
      transformResponse: (response: {
        getAllTdClients: UserManagementResponse;
      }) => response?.getAllTdClients,
    }),
    // Define the createUser mutation
    createUser: builder.mutation<
      AddEditUserResponse,
      { userData: ICreateUserInput }
    >({
      query: ({ userData }) => {
        return {
          document: CREATE_USER,
          variables: { userData },
        };
      },
      invalidatesTags: ["userManagement"],
    }),
    editUser: builder.mutation<
      AddEditUserResponse,
      { userId: string; userData: IUpdateUserInput }
    >({
      query: (body) => {
        return {
          document: EDIT_USER,
          variables: { ...body },
        };
      },
      invalidatesTags: ["userManagement"],
    }),
    deleteUser: builder.mutation<AddEditUserResponse, { userId: string }>({
      query: (body) => {
        return {
          document: DELETE_USER,
          variables: body,
        };
      },
      invalidatesTags: ["userManagement"],
    }),
    updateUserStatus: builder.mutation<
      IUpdateUserStatusResponse,
      IUpdateUserStatusRequest
    >({
      query: ({ email, isRestricted }) => ({
        document: UPDATE_USER_STATUS,
        variables: {
          email,
          isRestricted,
        },
      }),
      invalidatesTags: ["userManagement"],
    }),
  }),
});

// Extract hook
export const {
  useGetAllTdClientsQuery,
  useCreateUserMutation,
  useEditUserMutation,
  useDeleteUserMutation,
  useUpdateUserStatusMutation,
} = userManagementApi;
